import $ from "jquery";
/* eslint-disable */
export default function search() {
  if ($(window).width() > 768) {
    // Search form
    var searchTimeout;
    $(".search-icon").click(function () {
      $(".wpsearchform").slideToggle();
      searchTimeout = setTimeout(function () {
        $(".wpsearchform").slideToggle();
      }, 5000);
    });

    $(".wpsearchform .search-field").on("focus", function (e) {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    });

    $(".wpsearchform .search-field").on("focusout", function (e) {
      searchTimeout = setTimeout(function () {
        $(".wpsearchform").slideToggle();
      }, 2000);
    });

    $(document).on("keyup", function (e) {
      if (e.key === "Escape") {
        $(".wpsearchform").hide();
      }
    });
  }
}
